<template>
    <div class="wrap wrap--join">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="inner">
                <h2 class="join-title">회원가입</h2>

                <div class="join-container">
                    <!-- 가입 단계 표시 -->
                    <nav class="join-step">
                        <ul class="join-step-lists">
                            <li class="list">
                                <span class="badge">1</span>
                                <span class="text">약관동의</span>
                            </li>
                            <li class="list">
                                <span class="badge">2</span>
                                <span class="text">정보입력</span>
                            </li>
                            <li class="list list--on">
                                <span class="badge">3</span>
                                <span class="text">가입완료</span>
                            </li>
                        </ul>
                    </nav>
                    <template v-if="hasAdditionalForm">
                        <div class="join-complate">
                            <i class="join-complate__icon"></i>
                            <h3 class="join-complate__title">회원가입이 완료 되었습니다.</h3>
                            <p class="join-complate__text mt-40" style="line-height: 1.5">
                                아래의 추가 입력 정보를 입력해 주세요.<br />
                                지금 입력하지 않아도 다음에 입력하실 수 있습니다.
                            </p>
                        </div>
                        <join-additional-form class="mt-100" v-bind="{ type, kind }" />
                    </template>
                    <template v-else>
                        <div class="join-complate">
                            <i class="join-complate__icon"></i>
                            <h3 class="join-complate__title">회원가입이 완료 되었습니다.</h3>
                            <p class="join-complate__text">가입해 주셔서 감사합니다.</p>
                        </div>
                        <!-- 하단버튼 -->
                        <div class="bottom-button">
                            <a class="button button--primary" href="/"><span>확인</span></a>
                        </div>
                    </template>
                </div>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import { INDIVIDUAL_KINDS } from "@/assets/variables";

import MainHeader from "../../../components/client/inc/main-header.vue";
import MainFooter from "../../../components/client/inc/main-footer.vue";
import JoinAdditionalForm from "@/components/client/join/join-additional-form.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        JoinAdditionalForm,
    },
    computed: {
        type() {
            return this.$route.query.type;
        },
        kind() {
            return this.$route.query.kind;
        },
        hasAdditionalForm() {
            return [INDIVIDUAL_KINDS.SUPPORTER.value].includes(this.kind);
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init: function () {},
    },
};
</script>
